import { useMutation } from "@tanstack/react-query";
import { fetchClient } from "../generated/client";

export type SimulateSizeBody = {
	productId: string;
	gender: "male" | "female";
	heightCm: number;
	weightKg: number;
	fitPreference?: "slim" | "regular" | "loose";
	age?: number;
};

export type SimulateSizeVariant = {
	label: string;
	variantId: string;
	rank: number;
	fit: string;
};

export type SimulateSizeResult = {
	recommendedVariantId: string;
	recommendedSize: string;
	allSizes: SimulateSizeVariant[];
	confidence: string;
	measureId?: string;
};

export default function useSimulateSize(shopId: string) {
	return useMutation({
		mutationFn: async (body: SimulateSizeBody): Promise<SimulateSizeResult> => {
			const { data, error } = await fetchClient.POST(
				"/shops/{shopId}/sizing/simulate",
				{
					params: { path: { shopId } },
					body,
				},
			);
			if (error) throw error;
			return data as SimulateSizeResult;
		},
	});
}
